import { Link } from "react-router-dom";
import { PageHero, SectionHeading, Reveal } from "@/components/Section";
import LogoMarquee from "@/components/LogoMarquee";
import { IMAGES } from "@/data/site";

const clients = [
  { name: "BUILD IT", role: "Building Materials Retailer", desc: "Build It is a leading building materials chain. We supply hardware, building materials and construction supplies to their operations." },
  { name: "MICA", role: "Hardware Retail Chain", desc: "We supply Mica with a range of hardware and building products across their store network. A longstanding supply relationship built on consistent quality and reliable delivery." },
  { name: "SI HARDWARE", role: "Independent Hardware Retailer", desc: "One of our independent hardware retail clients. We supply SI Hardware with the full range of hardware and construction materials at best prices." },
  { name: "DADA'S WORLD OF HARDWARE", role: "Independent Hardware Retailer", desc: "Hardware supply for Dada's World of Hardware — consistent, reliable, competitively priced." },
  { name: "EXPORT CLIENTS", role: "International · Malawi, Tanzania & Africa", desc: "Established export clients across the continent. We manage the full export supply chain — hardware, building materials, mining equipment and commodities — into Malawi, Tanzania and beyond.", gold: true },
];

const Clients = () => {
  return (
    <>
      <PageHero
        label="OUR CLIENTS"
        title="WHO TRUSTS US. WHY THEY STAY."
        subtitle="23 years. Leading hardware and construction chains. International exporters. Contractors across regions. Here's who we serve."
        image={IMAGES.warehouseAlt}
      />

      <LogoMarquee label="ACTIVE B2B PARTNERS · UPDATED 2026" />

      <section className="bg-[#F8F6F2] py-24">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10">
          <SectionHeading label="CLIENT SHOWCASE" title="LONG-TERM B2B RELATIONSHIPS." />
          <div className="grid md:grid-cols-2 gap-6">
            {clients.map((c, i) => (
              <Reveal key={c.name} delay={i*70}>
                <div className={`cg-card-dark ${c.gold ? "cg-card-gold" : ""} h-full`} style={{background:"#1E2D40"}} data-testid={`client-${c.name.toLowerCase().replace(/\s|\(|\)|\./g,'-')}`}>
                  <div className={`text-[12px] tracking-[.22em] font-bold ${c.gold ? "text-[#C8973C]" : "text-[#E8721C]"}`}>{c.role}</div>
                  <h4 className="font-display text-[26px] md:text-[32px] mt-2">{c.name}</h4>
                  <p className="mt-4 text-[#cbd3df] leading-7">{c.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#E8721C] py-20">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10 grid md:grid-cols-2 gap-8 items-center">
          <h3 className="font-display text-[40px] md:text-[58px] text-[#0A1628] leading-[1]">YOUR COMPANY SHOULD BE ON THIS LIST.</h3>
          <div>
            <p className="text-[#0A1628]/85 text-[17px] leading-7">If you're a contractor, retailer or importer looking for a reliable supply partner — this is where the conversation starts.</p>
            <Link to="/contact" className="btn-navy mt-6">Get in Touch</Link>
          </div>
        </div>
      </section>
    </>
  );
};
export default Clients;
